import Settings from "../../models/Settings";

export const SETTINGS_FETCHED = "SETTINGS_FETCHED";
export type SETTINGS_FETCHED = { settings: Settings }
